module.exports = __webpack_public_path__ + "static/media/JCB.623af2ef.svg";